import React, { useEffect, useState } from 'react';
import { useTheme } from '../../../../../ThemeContext';
import { useUIControls } from '@jwp/ott-hooks-react/src/useUIControls';

const getCookie = (name: string) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
};

const setCookie = (name: string, value: string, days: number) => {
  const expires = new Date(Date.now() + days * 86400000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
};

export const CookiesConfirmation = () => {
  const { universalStyles } = useTheme();
  const [showModal, setShowModal] = useState(false);
  const { cookieConsentName, cookiesButton, cookiesDescription, cookiesExpiredDays } = useUIControls();
  const COOKIE_NAME = cookieConsentName || 'ott-cookies';

  useEffect(() => {
    const accepted = getCookie(COOKIE_NAME);

    if (!accepted) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
      setShowModal(true);
    }
  }, []);

  const handleAccept = () => {
    setCookie(COOKIE_NAME, 'accepted', Number(cookiesExpiredDays));
    document.body.style.pointerEvents = 'auto';
    document.body.style.overflow = 'auto';
    setShowModal(false);
  };

  // useEffect(() => {
  //   if (!getCookie(COOKIE_NAME)) {
  //     const observer = new MutationObserver(() => {
  //       if (!document.getElementById('cookie-overlay')) {
  //         window.location.reload();
  //       }
  //     });

  //     observer.observe(document.body, { childList: true, subtree: true });
  //     return () => observer.disconnect();
  //   }
  // }, []);

  if (!showModal) return null;

  return (
    <div
      id="cookie-overlay"
      style={{
        position: 'fixed',
        zIndex: 999999999999999999,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'auto',
      }}
    >
      <div
        style={{
          background: universalStyles.modalBackgroundColors.backgroundColor,
          padding: '24px',
          borderRadius: '8px',
          width: '90%',
          maxWidth: '500px',
          textAlign: 'center',
        }}
      >
        <p style={{ marginBottom: '20px' }}>{cookiesDescription}</p>
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
          <button
            style={{
              fontSize: '14px',
              ...universalStyles.signUpButton,
              ...universalStyles.signUpButtonText,
              borderRadius: '4px',
              border: `1px solid ${universalStyles.seeMoreText.color}`,
              padding: '8px 20px',
              cursor: 'pointer',
              backgroundColor: universalStyles.seeMoreText.color,
              color: '#fff',
            }}
            onClick={handleAccept}
          >
            {cookiesButton}
          </button>
        </div>
      </div>
    </div>
  );
};
